<template>
    <div class="error">
        <div class="error-container">
            <div class="error-icon">
                <i class="fal fa-lock"></i>
            </div>
            <div class="error-content">
                <h1 class="title">Acesso Restrito.</h1>
                <h4 class="subtitle">{{ textRestrict }}</h4>
                <ul class="messages">
                    <li v-for="(permission, index) in errorPermissions" :key="index">
                        {{ permission }}
                    </li>
                </ul>
                <ui-button design="md primary" @click="redirectHome">Voltar para página inicial</ui-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { uiButton } from "@/components/ui/buttons"

    import { mapGetters } from 'vuex'

    export default {
        components: {
            uiButton,
        },

        computed: {
            ...mapGetters('auth', {
                errorPermissions: 'getUnauthorizedPermissions'
            }),
            textRestrict() {
                return this.errorPermissions && this.errorPermissions.length > 0 ? 'Você precisa de permissões específicas para acessar esta página.' : 'Você não tem permissão para acessar esta página.'
            }
        },

        methods: {
            redirectHome() {
                this.$router.push('/')
            }
        },

        beforeRouteLeave (to, from, next) {
            /**
             * Antes de deixar a página de erro, remove as informações das permissões
             * faltantes que já foram apresentadas para o usuário
             */
            this.$store.dispatch('auth/clearUnauthorizedPermissions')
            next()
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>